import { action, observable } from 'mobx';
import { IGame } from '../types';
import { appLocalStore } from '../stores/appLocalStore';

/*
    This class can potentially be part of App by has been split out for clarity.
*/

class GameLoaderService {
    @observable accessor gameId: string | null = null;
    @observable accessor game: IGame | null = null;
    @observable accessor state: "none" | "loading" | "loaded" | "error" = "none";

    @action
    action(callback: (self: this) => void) {
        callback(this);
    }

    async loadGame(gameId: string | null): Promise<void> {

        if (gameId != this.gameId) {
            this.game?.gameService.destroy();
            this.action(_ => {
                _.game = null;
                this.state = "none"
            }); 
            
        } else {
            return;
        }

        this.action(_ => {
            _.gameId = gameId;
            _.state = "loading"
        });

        try {
            // TODO - Implement some type of retry

            // Dynamic import of the game module
            const loadedGame = (await import(`../games/${gameId}/index.ts`)).default as IGame;

            console.log(`[GameLoaderService] Successfully loaded game "${gameId}".`);
            if (this.gameId != gameId) {
                // A new load request has been made since this one started
                return;
            }

            this.action(_ => {
                _.game = loadedGame;
                _.state = "loaded";
            });

            loadedGame.gameService.afterLoad();
        } catch (error) {
            console.error(`[GameLoaderService] Failed to load game "${gameId}":`, error);
            this.action(_ => {
                _.state = "error";
                appLocalStore.addErrorAction(`Failed to load game "${gameId}".`);
            });

        }
    }
}

export const gameLoaderService = new GameLoaderService();
